import React from 'react';
import PropTypes from 'prop-types';
import * as Classes from './TableOfContent.module.scss';
import TableTitle from './TableTitle/TableTitle';
import Navigation from './Navigation/Navigation';
import Share from './Share/Share';
import { testAttributes } from './Constants';

export default function TableOfContent({ articleTitles, share = false, headline = false }) 
{
    if (!articleTitles || articleTitles.length === 0) 
    {
        return null;
    }

    const renderShare = () => 
    share ? <Share /> : null
    return (
        <aside
            className={Classes.table}
            data-testid={testAttributes.TABLE_OF_CONTENT}
        >
            <TableTitle label={headline} />
            <Navigation data={articleTitles} />
            {renderShare()}
        </aside>
    );
}

TableOfContent.propTypes = {
    articleTitles: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            anchor: PropTypes.string,
        })
    ).isRequired,
    share: PropTypes.bool,
    headline: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
};
